import gql from 'graphql-tag';

const GET_CATEGORIES_PEDIDO = gql`
    query getOrderCategories {
        getOrderCategories {
            status
            message
            data {
                id
                idCategory
                description
            }
        }
    }
`;

export default GET_CATEGORIES_PEDIDO;
